// Chargement des sprites depuis public/assets/<thème>/ (servi à la racine par Vite).
// Les nez sont communs à tous les thèmes ; les doigts sont déclarés par le thème.

import type { Theme } from "./themes";

export type SpriteName =
  | "nez_0"
  | "nez_1"
  | "nez_2"
  | "nez_3"
  | "nez_0_mask"
  | "nez_1_mask"
  | "nez_2_mask"
  | "nez_3_mask"
  | "index"
  | "majeur"
  | "annulaire"
  | "index-majeur"
  | "index_mask"
  | "majeur_mask"
  | "annulaire_mask"
  | "index-majeur_mask";

export type Sprites = Record<SpriteName, HTMLImageElement>;

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Impossible de charger ${src}`));
    img.src = src;
  });
}

export async function loadSprites(theme: Theme): Promise<Sprites> {
  // Frames de nez utilisées par le thème (repos + réactions), chacune avec masque + occulteur.
  const frames = [
    ...new Set<SpriteName>([
      "nez_0",
      ...theme.reactions.left,
      ...theme.reactions.right,
      ...theme.reactions.both,
    ]),
  ];
  const noseNames = frames.flatMap((f) => [f, `${f}_mask`] as SpriteName[]);
  // Doigts déclarés par le thème (sprite + son masque).
  const fingerNames = theme.fingers.flatMap(
    (f) => [f.name, `${f.name}_mask`] as SpriteName[],
  );
  const names = [...noseNames, ...fingerNames];
  const images = await Promise.all(names.map((n) => loadImage(`assets/${theme.key}/${n}.png`)));
  const out = {} as Sprites;
  names.forEach((name, i) => (out[name] = images[i]!));
  return out;
}
